import {
  EResourceCrud,
  FilterParams,
  PaginationParams,
  SorterParams,
} from "@project/shared-types";
import axios from "axios";

const apiClient = axios.create({
  baseURL: `/api/admin/`, // Замените на ваш базовый URL
});
export interface CrudProviderOptions {
  resource: EResourceCrud;
}

export const makeCrudDataProvider = (options: CrudProviderOptions) => {
  const { resource } = options;

  const getAuthHeaders = () => {
    return { Authorization: `Bearer ${localStorage.getItem("viw_token")}` };
  };

  return {
    async getList<T>(params: {
      filters?: FilterParams[];
      pagination?: PaginationParams;
      sorters?: SorterParams[];
    }): Promise<{ data: T[]; total: number }> {
      const res = await apiClient.post(
        `${resource}/get_list`,
        {
          filters: params.filters ?? [],
          pagination: params.pagination ?? { current: 1, pageSize: 20 },
          sorters: params.sorters ?? [],
        },
        { headers: getAuthHeaders() }
      );
      return res.data;
    },

    async getOne<T>(id: string | number): Promise<T> {
      const res = await apiClient.post(
        `${resource}/get`,
        { id },
        { headers: getAuthHeaders() }
      );
      return res.data;
    },

    async create<T>(data: any): Promise<T> {
      const res = await apiClient.post(`${resource}/create`, data, {
        headers: getAuthHeaders(),
      });
      return res.data;
    },

    async update<T>(id: string | number, data: any): Promise<T> {
      const res = await apiClient.post(
        `${resource}/update`,
        { id, ...data },
        {
          headers: getAuthHeaders(),
        }
      );
      return res.data;
    },

    async delete<T>(id: string | number): Promise<T> {
      const res = await apiClient.post(
        `${resource}/delete`,
        { id },
        {
          headers: getAuthHeaders(),
        }
      );
      return res.data;
    },
  };
};
